import { FormattedMessage } from "react-intl";
import { useAuth } from "react-oidc-context";
import { useCallback } from "react";
import { Typography } from "antd";

import { signOut } from "../../../modules/userSession";

const { Text } = Typography;

const SignOut = () => {
  const auth = useAuth();
  const logout = useCallback(() => signOut(auth), [auth]);

  return (
    auth.isAuthenticated && (
      <Text onClick={logout}>
        <FormattedMessage id="messages.logout" defaultMessage="Odhlásit" />
      </Text>
    )
  );
};

export default SignOut;
